import { type ReactNode } from 'react'
import { type IntlShape } from 'react-intl'

import { shippingAccessorGetFormattedShippingLeadTime as shippingGetFormattedLeadTime } from '../../../shipping'

export const shippingAccessorGetFormattedShippingLeadTime = (
  intl: IntlShape,
  deliveryTime?: {
    earliestDays?: number
    latestDays?: number
  },
): ReactNode => {
  return shippingGetFormattedLeadTime({
    deliveryTime,
    fallbackLabel: intl.formatMessage({
      id: 'general.label.product.available',
    }),
    intl,
  })
}
